import { GEAR_ACTIONS_ALLOWED_FOR_DOCUMENT, GearUserAllowedActions } from '../Model/enums/GearUserAllowedActions';
import { SearchFolder } from '../Model/SearchFolder';

export class DocumentsGridHelper {
  public static getSearchResultKey = (folder: SearchFolder, searchKey?: string) => {
    return `${folder?.id || ''}_${searchKey || ''}`;
  };

  public static getActionsFromFlag = (flag: number): GearUserAllowedActions[] => {
    const actions: GearUserAllowedActions[] = [];

    for (const action of Object.keys(GEAR_ACTIONS_ALLOWED_FOR_DOCUMENT)) {
      const actionValue = GEAR_ACTIONS_ALLOWED_FOR_DOCUMENT[action as keyof typeof GEAR_ACTIONS_ALLOWED_FOR_DOCUMENT];
      if (typeof actionValue === 'number' && (flag & actionValue) === actionValue) {
        actions.push(actionValue);
      }
    }

    return actions;
  };
}
